import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/views/components/ToggleSwitchButton.module.scss';

const ToggleSwitchButton = ({
  isDisabled,
  isChecked,
  handleChange,
  isSmall,
  customeWrapperStyles,
  checkedText,
  uncheckedText,
  disabledText,
  tooltip,
  isTextFirst,
  customTextStyles,
}) => (
  <div
    className={[
      styles.toggleSwitchWrapper,
      isSmall && styles.small,
      isTextFirst && styles.textFirst,
      customeWrapperStyles,
    ].join(' ')}
    data-tip={tooltip}
  >
    <label className={styles.switch}>
      <input
        type="checkbox"
        checked={isChecked}
        disabled={isDisabled}
        onChange={handleChange}
      />
      <div className={`${styles.slider} ${isDisabled ? styles.disabledSlider : ''}`} />
    </label>

    <span className={[styles.status, customTextStyles].join(' ')}>
      {(isDisabled && disabledText) || (isChecked
        ? checkedText
        : uncheckedText)
      }
    </span>
  </div>
);

ToggleSwitchButton.propTypes = {
  handleChange: PropTypes.func.isRequired,
  customeWrapperStyles: PropTypes.string,
  isDisabled: PropTypes.bool,
  isChecked: PropTypes.bool,
  isSmall: PropTypes.bool,
  checkedText: PropTypes.string,
  uncheckedText: PropTypes.string,
  disabledText: PropTypes.string,
  tooltip: PropTypes.string,
  isTextFirst: PropTypes.bool,
  customTextStyles: PropTypes.string,
};

ToggleSwitchButton.defaultProps = {
  customeWrapperStyles: '',
  isDisabled: false,
  isChecked: false,
  isSmall: false,
  checkedText: '',
  uncheckedText: '',
  disabledText: '',
  tooltip: '',
  isTextFirst: false,
  customTextStyles: '',
};


export default ToggleSwitchButton;
